module.exports = json2Plugin

function json2Plugin() {
	require('./lib/json2')
	return {}
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/store/plugins/json2.js
// module id = 112
// module chunks = 1